import { useState, useContext } from 'react';
import styles from './Channels.module.css';
import { CHANNELS } from '../../constant-data';
import '../Style/Table-style.css';
import fontSize from '../Style/FontSize.module.css';
import common from '../Style/common.module.css';
import font from '../Style/FontFamily.module.css';
import button from '../Style/ButtonStyle.module.css';
import AuthContext from '../../store/auth-context';
import '../Style/FormStyle.css';
import { parseJToken } from '../../services/notification.services';
import tableStyle from '../Style/TableModel.module.css';
import Modal from 'react-modal';

// Inline styles
const tabButtonStyle = (isActive: boolean) => ({
    flex: 1,
    padding: '5px 10px',
    background: 'transparent',
    border: 'none',
    borderBottom: isActive ? '2px solid #0f6cbd' : '2px solid transparent',
    color: isActive ? '#0f6cbd' : '#8E8E8E',
    fontWeight: isActive ? '400' : '400',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    marginBottom: '-2px'
});

const sectionLabelStyle = {
    color: '#BDBDBD',
    fontSize: '12px',
    fontWeight: '400',
    letterSpacing: '0.5px',
    marginBottom: '12px',
    textTransform: 'uppercase' as const
};

const composeButtonStyle = {
    padding: '5px 20px',
    background: '#FF6D73',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: '400',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px'
};

const SVGIcon = ({ svgIcondata }: { svgIcondata: string }) => (
    <p style={{ margin: '0' }} dangerouslySetInnerHTML={{ __html: svgIcondata }} />
);

const ChannelCheckbox = ({ channel, isChecked, onChange, authCtx, isDisabled = false }) => {
    const id = `channelId_${channel.id}`;
    const displayName = channel.name === 'Push Notification' && authCtx.userData.CHANNEL_PUSH_NOTIFICATION !== '1'
        ? 'Push Notification'
        : channel.name;

    return (
        <li className={styles.firstLi} id={`channel_option_${channel.id}`}>
            <div className="form-check channel-check">
                <input
                    onChange={onChange}
                    className="form-check-input"
                    checked={isChecked}
                    type="checkbox"
                    value={channel.id}
                    id={id}
                    disabled={isDisabled}
                />
                <label className="form-check-label" htmlFor={id}>
                    <span className={styles.iconArea}><SVGIcon svgIcondata={channel.svgIcon} /></span>
                    <span className={`${fontSize.font13} ${font.fontMedium}`}>{displayName}</span>
                </label>
            </div>
        </li>
    );
};

const Channels = (props) => {
    const [modalIsOpen, setIsOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('group-broadcast');
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedChannels, setSelectedChannels] = useState([]);
    
    const authCtx = useContext(AuthContext);
    const { resetChannelsHandler, setSelectedChannelsForValidation, onCompose, onDirectCompose, onComposeChannels } = props;
    const groupChannels = CHANNELS.filter(channel => channel.id !== '5');

    const channelHandler = (e) => {
        const id = e.target.value;
        const channels = selectedChannels.includes(id)
            ? selectedChannels.filter(ch => ch !== id)
            : [...selectedChannels, id];
        
        setSelectedChannels(channels);
        setSelectedChannelsForValidation(channels);
    };

    const handleCompose = () => {
        if (selectedChannels.length === 5) {
            setIsOpen(true);
        } else {
            onComposeChannels(selectedChannels);
            onCompose();
        }
    };

    const handleComposeConfirm = () => {
        onComposeChannels(selectedChannels);
        onCompose();
    };

    const handleComposeDM = () => {
        // Set channels directly for DM (Push + Email + Private Message)
        onComposeChannels(['1', '2', '5']);
        // Use directComposeHandler to skip validation since channels are set directly
        onDirectCompose();
    };

    return (
        <div 
            className={styles.channeldropdown} 
            onClick={(e) => e.stopPropagation()}
            style={{ 
                background: 'white', 
                padding: '16px', 
                borderRadius: '8px',
                overflow: 'hidden',
                maxWidth: '100%'
            }}
        >
            {/* Tab Navigation */}
            <div style={{ display: 'flex', borderBottom: '2px solid #e0e0e0', marginBottom: '20px' }}>
                <button onClick={(e) => { e.stopPropagation(); setActiveTab('group-broadcast'); }} style={tabButtonStyle(activeTab === 'group-broadcast')}>
                    Group Messages
                </button>
                <button onClick={(e) => { e.stopPropagation(); setActiveTab('private-message'); }} style={tabButtonStyle(activeTab === 'private-message')}>
                    Direct (private) Messages
                </button>
            </div>

            {/* Group Broadcast Tab */}
            {activeTab === 'group-broadcast' && (
                <div style={{ overflow: 'auto', maxHeight: '400px' }}>
                    <div style={sectionLabelStyle}>SELECT CHANNELS</div>
                    <ul style={{ margin: 0, padding: 0, listStyle: 'none', position: 'relative', background: 'transparent', boxShadow: 'none' }}>
                        {groupChannels.filter((channel) => (channel as any).displayname !== 'disabled').map((channel) => (
                            <ChannelCheckbox
                                key={channel.id}
                                channel={channel}
                                isChecked={selectedChannels.includes(channel.id)}
                                onChange={channelHandler}
                                authCtx={authCtx}
                            />
                        ))}
                    </ul>
                    <div style={{ marginTop: '20px', textAlign: 'right' }}>
                        <button type="button" onClick={handleCompose} style={composeButtonStyle}>
                            Compose
                        </button>
                    </div>
                </div>
            )}

            {/* Private Message Tab */}
            {activeTab === 'private-message' && (
                <div style={{ overflow: 'auto', maxHeight: '400px' }}>
                    {/* TODO: Implement user search for later release */}
                    {/* <div style={sectionLabelStyle}>RECIPIENT</div>
                    <div style={{
                        background: '#F5F7FA',
                        borderRadius: '8px',
                        padding: '12px 16px',
                        marginBottom: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                    }}>
                        <span style={{ color: '#5865F2', fontSize: '18px' }}>❓</span>
                        <input
                            type="text"
                            placeholder="Search for a user..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            style={{
                                flex: 1,
                                background: 'transparent',
                                border: 'none',
                                outline: 'none',
                                fontSize: '14px',
                                color: '#424242'
                            }}
                        />
                    </div> */}
                    <p style={{ color: '#BDBDBD', fontSize: '13px', lineHeight: '1.5', marginBottom: '40px' }}>
                        Send a direct, private message to a subscriber.
                    </p>
                    <div style={{ textAlign: 'right' }}>
                        <button type="button" onClick={handleComposeDM} style={composeButtonStyle}>
                            Compose
                        </button>
                    </div>
                </div>
            )}

            {/* Confirmation Modal */}
            <Modal isOpen={modalIsOpen} className="alertBgContainer" contentLabel="Example Modal">
                <div className='alertBox'>
                    <h4 className={tableStyle.alertTitle}>Alert</h4>
                    <p className={`${fontSize.smSize} ${font.fontRegular} ${common.pTag}`}>
                        <b className={font.fontBold}>Confirm if you wish to post this message to (all selected) multiple communication channels,</b> e.g. If you selected SchoolLink notifications & email, then this message will be sent via both channels.
                    </p>
                    <div className='bottomArea'>
                        <button onClick={() => setIsOpen(false)} className={`${button.smBtn} ${button.lightBrownButton}`}>
                            Cancel
                        </button>
                        <button onClick={handleComposeConfirm} className={`${button.smBtn} ${button.blueButton} ${button.buttonSpaceLeft}`}>
                            Yes
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default Channels;
